import { __read } from "tslib";
import CarouselControl, { CarouselHeaderType, CarouselPeek, } from '@office-start/carousel-control';
import { FileType, } from '@office-start/document-types';
import { RecommendedCardControl, RecommendedCompositeCardControl, RecommendedFileCardControl, RecommendedMeetingCardControl, RecommendedSuggestedTaskCardControl, } from '@office-start/recommended-card-control';
import { RecommendedCardType, } from '@office-start/recommended-types';
import React, { useCallback, useEffect, useState } from 'react';
var responsiveBreakpointsHome = {
    Small: {
        width: 296,
        height: 300,
        maxWidth: 296,
        minWidth: 296,
    },
    Medium: {
        width: 456,
        height: 300,
        maxWidth: 456,
        minWidth: 297,
    },
    Large: {
        width: 378,
        height: 300,
        maxWidth: 611,
        minWidth: 296,
    },
    ExtraLarge: {
        width: 359.33,
        height: 300,
        maxWidth: 453.5,
        minWidth: 296,
    },
    ExtraExtraLarge: {
        width: 403,
        height: 300,
        maxWidth: 403,
        minWidth: 296,
    },
    ExtraExtraExtraLarge: {
        width: 403,
        height: 300,
        maxWidth: 403,
        minWidth: 403,
    },
};
var responsiveBreakpointsStartPages = {
    Small: {
        width: 368,
        height: 270,
    },
    Medium: {
        width: 368,
        height: 270,
    },
    Large: {
        width: 368,
        height: 270,
    },
    ExtraLarge: {
        width: 368,
        height: 270,
    },
    ExtraExtraLarge: {
        width: 368,
        height: 270,
    },
    ExtraExtraExtraLarge: {
        width: 368,
        height: 270,
    },
};
export var RecommendedControl = function (_a) {
    var PeopleCard = _a.PeopleCard, carouselResources = _a.carouselResources, callbacks = _a.callbacks, createActions = _a.createActions, dateResources = _a.dateResources, documents = _a.documents, edgeworthItemResources = _a.edgeworthItemResources, isVisualRefresh = _a.isVisualRefresh, moreActionsButtonAriaLabel = _a.moreActionsButtonAriaLabel, preferredCulture = _a.preferredCulture, sectionTitle = _a.sectionTitle, showAppIcon = _a.showAppIcon, thumbnailPreviewBackgroundColor = _a.thumbnailPreviewBackgroundColor, isUseFeedApi = _a.isUseFeedApi, recommendedSectionResources = _a.recommendedSectionResources, isStackedMeetingsEnabled = _a.isStackedMeetingsEnabled, isMeetingInsightsEnabled = _a.isMeetingInsightsEnabled;
    var getItemDimensionsForBreakpoint = function (breakpoint) {
        return isUseFeedApi
            ? responsiveBreakpointsHome[breakpoint]
            : responsiveBreakpointsStartPages[breakpoint];
    };
    var _b = __read(useState(new Map()), 2), primaryActionMap = _b[0], setPrimaryActionMap = _b[1];
    useEffect(function () {
        var actionMap = new Map(); //item id, true - if primary action is add, false - if primary action is view
        documents.map(function (document) {
            if (!('items' in document) &&
                document.fileType &&
                document.fileType === FileType.MyAnalytics) {
                actionMap.set(document.id, true);
            }
        });
        setPrimaryActionMap(actionMap);
    }, [documents]);
    var updatePrimaryActionMap = useCallback(function (item) {
        setPrimaryActionMap(function (oldMap) { return new Map(oldMap.set(item.id, false)); });
    }, []);
    var renderItem = useCallback(function (document, index, relativeIndex, ref, lastVisibleIndex) {
        var _a;
        var itemId = "rec-item-".concat(index);
        var allDocumentActions = (createActions === null || createActions === void 0 ? void 0 : createActions(document, index, itemId, lastVisibleIndex ? index === lastVisibleIndex : false)) || {
            actionMenuItems: [],
            commandItems: [],
        };
        if (isStackedMeetingsEnabled &&
            document.items) {
            var item_1 = document;
            return (React.createElement("div", { id: itemId },
                React.createElement(RecommendedCompositeCardControl, { PeopleCard: PeopleCard, carouselResources: carouselResources, createActions: createActions, onCarouselNavigationClick: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onCarouselNavClick, onUserClick: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onUserClick, dateResources: dateResources, item: item_1, moreActionsButtonAriaLabel: moreActionsButtonAriaLabel, onDocClick: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onDocumentClick, onMeetingInsightsDocClick: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onMeetingInsightsDocClick, onBookFocusTimeClick: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onBookFocusTimeClick, index: index, preferredCulture: preferredCulture, recommendedSectionResources: recommendedSectionResources, isMeetingInsightsEnabled: isMeetingInsightsEnabled, ref: ref })));
        }
        var item = document;
        var onSetPrimaryAction = function () {
            updatePrimaryActionMap(item);
        };
        switch (item.fileType) {
            case FileType.UpcomingMeeting: {
                return (React.createElement("div", { id: itemId },
                    React.createElement(RecommendedMeetingCardControl, { PeopleCard: PeopleCard, dateResources: dateResources, documentActions: allDocumentActions, item: item, moreActionsButtonAriaLabel: moreActionsButtonAriaLabel, onDocClick: function (event) {
                            var _a;
                            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onDocumentClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, document, index, relativeIndex, 'Recommended', event, RecommendedCardType.UpcomingMeeting);
                        }, onJoinMeetingClick: function (event) {
                            var _a;
                            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onJoinMeetingClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, item, index, relativeIndex, 'Recommended', event);
                        }, onMeetingInsightsDocClick: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onMeetingInsightsDocClick, preferredCulture: preferredCulture, recommendedSectionResources: recommendedSectionResources, isMeetingInsightsEnabled: isMeetingInsightsEnabled, ref: ref })));
            }
            case FileType.MyAnalytics: {
                return (React.createElement("div", { id: itemId },
                    React.createElement(RecommendedSuggestedTaskCardControl, { PeopleCard: PeopleCard, dateResources: dateResources, documentActions: allDocumentActions, preferredCulture: preferredCulture, item: item, moreActionsButtonAriaLabel: moreActionsButtonAriaLabel, isPrimaryActionAdd: (_a = primaryActionMap.get(item.id)) !== null && _a !== void 0 ? _a : true, onDocClick: function (event) {
                            var _a;
                            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onDocumentClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, document, index, relativeIndex, 'Recommended', event, RecommendedCardType.SuggestedTask);
                        }, onAddToToDoClick: function (event) {
                            var _a;
                            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onAddToToDoClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, item, index, relativeIndex, onSetPrimaryAction, 'Recommended', event);
                        }, onMarkAsDoneClick: function (event) {
                            var _a;
                            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onMarkAsDoneClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, item, index, relativeIndex, 'Recommended', event);
                        }, onViewToDoClick: function (event) {
                            var _a;
                            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onViewToDoClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, event);
                        }, getPersonPicture: callbacks === null || callbacks === void 0 ? void 0 : callbacks.getActivityPersonPicture, recommendedSectionResources: recommendedSectionResources, ref: ref })));
            }
            default: {
                return (React.createElement("div", { id: itemId }, isUseFeedApi ? (React.createElement(RecommendedFileCardControl, { item: document, onDocClick: function (event) {
                        var _a;
                        (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onDocumentClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, document, index, relativeIndex, 'Recommended', event, RecommendedCardType.File);
                    }, dateResources: dateResources, moreActionsButtonAriaLabel: moreActionsButtonAriaLabel, preferredCulture: preferredCulture, documentActions: allDocumentActions, edgeworthItemResources: edgeworthItemResources, getDocumentThumbnail: callbacks === null || callbacks === void 0 ? void 0 : callbacks.getDocumentThumbnail, getPersonPicture: callbacks === null || callbacks === void 0 ? void 0 : callbacks.getActivityPersonPicture, PeopleCard: PeopleCard, recommendedSectionResources: recommendedSectionResources, ref: ref })) : (React.createElement(RecommendedCardControl, { item: document, onDocClick: function (event) {
                        var _a;
                        (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onDocumentClick) === null || _a === void 0 ? void 0 : _a.call(callbacks, document, index, relativeIndex, 'StartPage', event);
                    }, dateResources: dateResources, moreActionsButtonAriaLabel: moreActionsButtonAriaLabel, preferredCulture: preferredCulture, documentActions: allDocumentActions, edgeworthItemResources: edgeworthItemResources, getDocumentThumbnail: callbacks === null || callbacks === void 0 ? void 0 : callbacks.getDocumentThumbnail, getPersonPicture: callbacks === null || callbacks === void 0 ? void 0 : callbacks.getActivityPersonPicture, showAppIcon: showAppIcon, thumbnailPreviewBackgroundColor: thumbnailPreviewBackgroundColor, PeopleCard: PeopleCard }))));
            }
        }
    }, [
        createActions,
        isStackedMeetingsEnabled,
        callbacks,
        carouselResources,
        dateResources,
        moreActionsButtonAriaLabel,
        preferredCulture,
        recommendedSectionResources,
        isMeetingInsightsEnabled,
        updatePrimaryActionMap,
        primaryActionMap,
        isUseFeedApi,
        edgeworthItemResources,
        showAppIcon,
        thumbnailPreviewBackgroundColor,
        PeopleCard,
    ]);
    return (React.createElement("div", { id: "recommended", style: { paddingTop: '20px' } },
        React.createElement(CarouselControl
        // arrowKeyListNavEnabled={isUseFeedApi ? true : false} // TODO - enable this once we fix arrow navigation bug
        , { 
            // arrowKeyListNavEnabled={isUseFeedApi ? true : false} // TODO - enable this once we fix arrow navigation bug
            callbacks: callbacks, cardGutterWidth: 20, cards: documents, carouselBottomMargin: isUseFeedApi ? 50 : 24, carouselResources: carouselResources, carouselTitle: sectionTitle, direction: "ltr" // TODO: configure with RTL and LTR
            , getItemDimensionsForBreakpoint: getItemDimensionsForBreakpoint, headerOptions: { type: CarouselHeaderType.SubtitleTwo }, isVisualRefresh: isVisualRefresh !== null && isVisualRefresh !== void 0 ? isVisualRefresh : false, renderItem: renderItem, resizeOptions: isUseFeedApi
                ? {
                    type: CarouselPeek.Fixed,
                    peekSizePixels: 32,
                }
                : { type: CarouselPeek.Resize } })));
};
//# sourceMappingURL=RecommendedControl.js.map